import {
  compose, getContext, withHandlers,
} from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { closeModal } from '../../../../../../../state/ui/actions';
import { getModal } from '../../../../../../../state/ui/selectors';
import { leadsActions, leadsSelectors } from '../../../../../../../state/leads';
import DeleteNote from '../../../../../../projectsNotes/components/notesCRUD/deleteNote/deleteNote';

const mapStateToProps = (state, { selectedNoteId }) => ({
  isOpen: getModal(state)('deleteNoteModal'),
  note: leadsSelectors.getLeadNoteSelector(state)(selectedNoteId),
  isPending: leadsSelectors.getLeadActionPending(state)('deleteLeadNoteRequest'),
});

const mapDispatchToProps = ({
  onCloseModal: () => closeModal('deleteNoteModal'),
  deleteLeadNote: leadsActions.deleteLeadNoteRequest,
});

const onDeleteHandler = ({
  deleteLeadNote, onCloseModal, selectedNoteId: noteId, leadId: id, sortBy, order,
}) => () => {
  deleteLeadNote({ id, noteId }, {
    callbacks: {
      success: onCloseModal,
    },
    sortBy,
    order,
  });
};

const enhance = compose(
  getContext({
    selectedNoteId: PropTypes.number.isRequired,
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(['common']),
  withHandlers({
    onDelete: onDeleteHandler,
  }),
);

export default enhance(DeleteNote);
